/*
 * Author: Dw
 * File Created: Friday, 24-09-27 11:16 am
 * Last Modified: Wednesday, 25-04-09 01:43 pm, by Harper Yan
 */

import type { ImageLoaderProps, ImageProps as NextImageProps } from 'next/image';
import NextImage from 'next/image';
import { basePath } from '@/constants';

// 全局自定义 Loader 的类型定义
const customLoader = ({
  src,
  width,
  quality
}: ImageLoaderProps): string => {
  if (src.startsWith('http')) {
    // 远程图片：不添加 basePath
    return `${src}?w=${width}&q=${quality || 75}`;
  }

  // 本地图片：加上 basePath

  return `${basePath}${src}?w=${width}&q=${quality || 75}`;
};

// 自定义 Image 包装器类型：继承 next/image 的类型
type ImageProps = NextImageProps;
const Image: React.FC<ImageProps> = ({
  src,
  alt,
  width,
  height,
  ...props
}) => {
  return <NextImage alt={alt} height={height} loader={customLoader} // 使用自定义 Loader
  src={src} width={width} {...props} // 传递其他 next/image 支持的属性
  data-sentry-element="NextImage" data-sentry-component="Image" data-sentry-source-file="index.tsx" />;
};
export default Image;